import GameModel from "../../GameModel";
import Projection from "../../Projection";
import Effect from "./Effect";

export default class EffectManager extends GameModel {
    /**
     * @param {Projection} projection 
     */
    constructor(projection) {
        super();

        /**
         * @constant
         * @type {Projection}
         */
        this.projection = projection;
        
        // /**
        //  * @constant
        //  * @type {SoundEffectManager}
        //  */
        // this.soundEffectManager = soundEffectManager;

        /**
         * @constant
         * @type {Array.<Effect>}
         */
        this.spriteEffects = [];
        // /**
        //  * @constant
        //  * @type {Array.<TravelEffect>}
        //  */
        // this.travelEffects = [];
    }

    /**
     * @private
     * @param {Array.<Effect>} effectList 
     */
    resetEffectList(effectList) {
        if (effectList.length > 0) {
            for (let i = 0; i < effectList.length; i++) {
                effectList[i].reset(true);
            }
            effectList.length = 0;
        }
    }

    // updateEffectsForTurn() {
    //     if (this.areaEffects.length === 0) {
    //         return;
    //     }

    //     // // Apply physics to the area surrounding the visible part of the world.
    //     // const nearbyRadius = Settings.grid.regionPixelWidth + (this.projection.visibleHalfWidthWorld + this.projection.visibleHalfHeightWorld) / 2;

    //     // GridInversionOfControl.allNearbyRegions(this.worldGrid, this.projection, this.processAreaEffectsRegionCallback, 
    //     //     this.projection.gridCenter, nearbyRadius);
    // }

    /**
     * @param {number} frameTimeRatio 
     */
    updateEffectsForFrame(frameTimeRatio) {
        //this.updateEffectListForFrame(this.travelEffects, frameTimeRatio, true);
        this.updateEffectListForFrame(this.spriteEffects, frameTimeRatio, true);
    }

    /**
     * @param {Array.<Effect>} effectList
     * @param {number} frameTimeRatio
     * @param {boolean} resetFinishedEffects
     * @returns {boolean} True if an effect was removed.
     */
    updateEffectListForFrame(effectList, frameTimeRatio, resetFinishedEffects) {
        let removed = false;
        for (let i = effectList.length - 1; i >= 0; i--) {
            const effect = effectList[i];
            if (!effect || effect.isFinishedAndAvailable()) {
                effectList.splice(i, 1);
                removed = true;
                continue;
            }

            effect.updateEffectForFrame(frameTimeRatio);
            if (effect.isEffectFinished()) {
                // If the effect has not yet been reset, we need to do this now.
                if (resetFinishedEffects && !effect.isFinishedAndAvailable()) {
                    effect.reset(true);
                }
                effectList.splice(i, 1);
                removed = true;
            }
        }
        return removed;
    }

    /**
     * @param {Effect} effect
     */
    addEffect(effect) {
        this.addEffectWithSoundFlag(effect, true);
    }

    /**
     * @param {Effect} effect
     * @param {boolean} soundEnabled
     */
    addEffectWithSoundFlag(effect, soundEnabled) {
        if (!effect || effect.isFinishedAndAvailable()) {
            return;
        }

        // Should we check for effect visibility here?

        let effectList = this.spriteEffects;
        // const effectType = effect.getEffectType();
        // switch (effectType) {
        //     case EffectType.SPRITE_EFFECT:
        //         if (effect.isTravelEffect()) {
        //             effectList = this.travelEffects;
        //         }
        //         else {
        //             effectList = this.spriteEffects;
        //         }
        //         break;
        //     // case EffectType.AREA_EFFECT:
        //     //     effectList = this.areaEffects;
        //     //     break;
        //     default:
        //         console.log("EffectManager.addEffect() Unsupported effect type: " + effectType);
        //         return;
        // }

        // if (!effectList) {
        //     console.log('EffectManager.addEffectWithSound() no effect list identified. effectType=' + effectType);
        //     return;
        // }

        effectList.push(effect);

        // if (soundEnabled) {
        //     const soundEffect = effect.getSoundEffect();
        //     if (soundEffect) {
        //         this.soundEffectManager.playSound(soundEffect);
        //     }
        // }
    }

    // resetModel() {
    //     this.resetEffectManager();       
    // }

    resetEffectManager() {
        this.resetEffectList(this.spriteEffects);
        //this.resetEffectList(this.travelEffects);
    }

    ////////////////////////////////////
    // GameModel
    ////////////////////////////////////

    /**
     * @override
     */
    resetFull() {
        this.resetEffectManager();
    }

    /**
     * @override
     */
    resetForPrestige() {
        this.resetEffectManager();
    }

}